export default __webpack_public_path__ + "static/certificate-5k-square-6e9a79440ff23470babab06ae18a2fce.png";